import React from 'react';
import { ListItemRightActionsSC } from './list-item-right-actions.styled';
import IconButton, { IconButtonProps } from '../../../icon-button';

interface ListItemRightActionsProps {
  actions: Omit<IconButtonProps, 'size' | 'label' | 'shape'>[];
}

const ListItemRightActions: React.FunctionComponent<ListItemRightActionsProps> = ({ actions }) => {
  return (
    <ListItemRightActionsSC>
      {actions.map((a, i) => (
        <IconButton
          {...a}
          size="extra-small"
          shape="round"
          key={i}
          onClick={(e) => {
            e.stopPropagation();
            a.onClick?.(e);
          }}
        />
      ))}
    </ListItemRightActionsSC>
  );
};

export default React.memo(ListItemRightActions);
